import loginRouteData from "./login-route";
import userSignupRouteData from "./user-signup-route";
import adminMfaDetailsRouteData from "./admin-mfa-details-route";
import adminVerifyMfaTokenRouteData from "./admin-verify-mfa-token-route";

export default {
  "login": loginRouteData,
  "user-signup": userSignupRouteData,
  "admin-mfa-details": adminMfaDetailsRouteData,
  "admin-verify-mfa-token": adminVerifyMfaTokenRouteData,
};
